/* eslint-disable no-nested-ternary */
import axios from "axios";
import { useState, useEffect, useCallback } from "react";
import { ClipLoader } from "react-spinners";
import arrowIcon from "../../assets/icons/back-arrow.svg";


import { Animation, AnimationData } from "../../assets/glb/animations";
import GlossaryItem from "../GlossaryItem";
import {
  Container,
  PaginationContainer,
  NextPageButton,
  SkipFirstPageButton,
  SkipLastPageButton,
  PreviousPageButton,
  Header,
} from "./styles";

type GlossaryOptionType = {
  description: string;
  word: string;
  is_recognized: boolean;
  glosa: string;
  animation: Animation;
};

interface GlossaryComponentProps {
  setAnimation: React.Dispatch<React.SetStateAction<AnimationData[]>>;
  setHeaderAnimation: React.Dispatch<React.SetStateAction<AnimationData[]>>;
  onBack: () => void;
}

export function GlossaryComponent({
  setAnimation,
  setHeaderAnimation,
  onBack
}: GlossaryComponentProps) {
  const [glossaryOptions, setGlossaryOptions] = useState<GlossaryOptionType[]>();
  const [lastPage, setLastPage] = useState(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [notFoundGlossary, setNotFoundGlossary] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [loading, setLoading] = useState<boolean>(true);
  const [color] = useState("#ffffff");

  const [isMobile, setIsMobile] = useState <boolean>(false);

  const searchInput = document.getElementById("myInput") as HTMLInputElement;

  function getGlossaryItemsByTerm(
    searchTermFilter?: string,
    pageNumber?: number
  ) {
    const path = process.env.REACT_APP_API_URL;

    const options = {
      method: "POST",
      url: `${path}/glossary/get`,
      headers: { "Content-Type": "application/json" },
      data: {
        page: pageNumber,
        itemsPerPage: 20,
        searchTerm: searchTermFilter
      },
      rejectUnauthorized: false,
    };

    setLoading(true);
    return axios
      .create({withCredentials: true})
      .request(options)
      .then((response) => response.data)
      .then((data) => {
        setGlossaryOptions(data.items);
        setLastPage(data.page.numberPages);
        setCurrentPage(data.page.currentPage);
        if (data.items.length === 0) {
          setNotFoundGlossary(true);
        } else {
          setNotFoundGlossary(false);
        }
        return data;
      })
      .catch(() => {
        setNotFoundGlossary(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function getGlossaryItemsByLetter(
    searchLetterFilter?: string,
    pageNumber?: number
  ) {
    const path = process.env.REACT_APP_API_URL;

    const options = {
      method: "POST",
      url: `${path}/glossary/get`,
      headers: { "Content-Type": "application/json" },
      data: {
        page: pageNumber,
        itemsPerPage: 20,
        letter: searchLetterFilter
      },
      rejectUnauthorized: false,
    };

    setLoading(true);
    return axios
      .create({withCredentials: true})
      .request(options)
      .then((response) => response.data)
      .then((data) => {
        setGlossaryOptions(data.items);
        setLastPage(data.page.numberPages);
        setCurrentPage(data.page.currentPage);
        setNotFoundGlossary(false);
        return data;
      })
      .catch(() => {
        setNotFoundGlossary(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const skipFirstPage = () => {
    if (searchInput && searchInput.value.length > 1) {
      getGlossaryItemsByTerm(searchInput.value, 1);
    } else {
      getGlossaryItemsByLetter(searchInput ? searchInput.value : "", 1);
    }
  };

  const skipLastPage = () => {
    if (searchInput && searchInput.value.length > 1) {
      getGlossaryItemsByTerm(searchInput.value, lastPage);
    } else {
      getGlossaryItemsByLetter(searchInput ? searchInput.value : "", lastPage);
    }
  };

  const nextPage = () => {
    if (searchInput && searchInput.value.length > 1) {
      getGlossaryItemsByTerm(searchInput.value, currentPage + 1);
    } else {
      getGlossaryItemsByLetter(searchInput ? searchInput.value : "", currentPage + 1);
    }
  };
  const previousPage = () => {
    if (searchInput && searchInput.value.length > 1) {
      getGlossaryItemsByTerm(searchInput.value, currentPage - 1);
    } else {
      getGlossaryItemsByLetter(searchInput ? searchInput.value : "", currentPage - 1);
    }
  };

  useEffect(() => {
    const delay = setTimeout(() => {
      if (searchTerm === "") {
        getGlossaryItemsByLetter("", 1);
        setNotFoundGlossary(false);
        return;
      }

      if (searchTerm.length > 1) {
        getGlossaryItemsByTerm(searchTerm, 1);
      } else {
        getGlossaryItemsByLetter(searchTerm, 1);
      }

      setNotFoundGlossary(false);
    }, 300);

    return () => clearTimeout(delay);
  }, [searchTerm]);

  useEffect(() => {
    getGlossaryItemsByLetter("", 1);

    return () => {
    };
  }, []);

  useEffect (()=> {
    const checkScreen =()=> {
      setIsMobile(window.innerWidth <769 )
    }
    checkScreen();
    window.addEventListener('resize',checkScreen)
    return ()=> window.removeEventListener('resize',checkScreen)  
  },[]);

  function handleBack() {
    onBack();
  }

  const handleLibrasSelection = useCallback((detection: string) => {
    if (detection === 'voltar') {
      handleBack();
    }
  }, [searchInput]);

  useEffect(() => {
    const onLibrasEvent = (event: any) => {
      const num = event.detail.number;
      handleLibrasSelection(num);
    };

    window.addEventListener("LIBRAS_SELECTION", onLibrasEvent);

    return () => {
      window.removeEventListener("LIBRAS_SELECTION", onLibrasEvent);
    };
  }, [handleLibrasSelection]);

  return (
    <>
      <Container>
        {/* <Header>
          <button className="back-button hint" data-hint="Voltar" data-hint-placement="bottom" onClick={handleBack}>
            <img src={arrowIcon} alt="Voltar" />
          </button>
          <h1>Glossário</h1>
        </Header> */}
        { loading ? (
          <div className="CompleteChatLoading">
            { !isMobile && (
              <ClipLoader
              color={color}
              loading={loading}
              size={150}
              aria-label="Carregando..."
              data-testid="loader"
            />
            )}
            { isMobile && (
            <ClipLoader
              color={color}
              loading={loading}
              size={50}
              aria-label="Carregando..."
              data-testid="loader"
            />
            )}
          </div>
          ) : (
            <div>
              <div className="GlossarySearch">
                <form
                  className="SearchForm"
                  onSubmit={(e) => e.preventDefault()}
                >
                  <span className="material-icons-outlined Icon">search</span>

                  <input
                    type="text"
                    id="myInput"
                    className="input"
                    placeholder="Buscar"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />

                  { searchTerm && (
                    <span
                      className="material-icons-outlined ClearIcon"
                      onClick={() => setSearchTerm("")}
                    >
                      close
                    </span>
                  )}
                </form>
              </div>

              { notFoundGlossary ? (
                <span className="spanNotFound">Nenhum resultado encontrado</span>
                ) : (
                  <div className="GlossaryItems">
                    { glossaryOptions &&
                      glossaryOptions.map((item) => {
                        return (
                          <GlossaryItem
                            key={item.word}
                            word={item.word}
                            animation={item.animation}
                            description={item.description}
                            is_recognized={item.is_recognized}
                            glosa={item.glosa}
                            setAnimation={setAnimation}
                            setHeaderAnimation={setHeaderAnimation}
                          />
                        );
                      })}
                  </div>
                )
              }
            </div>
          )
        }
      </Container>
      <PaginationContainer>
        <SkipFirstPageButton
          onClick={skipFirstPage}
          disabled={currentPage === 1}
        >
          <span className="material-icons-outlined">skip_previous</span>
        </SkipFirstPageButton>
        <PreviousPageButton onClick={previousPage} disabled={currentPage === 1}>
          <span className="material-icons-outlined">arrow_left</span>
        </PreviousPageButton>
        <span className="countPages">
          {" "}
          {currentPage} de {lastPage}
        </span>
        <NextPageButton onClick={nextPage} disabled={currentPage === lastPage}>
          <span className="material-icons-outlined">arrow_right</span>
        </NextPageButton>
        <SkipLastPageButton
          onClick={skipLastPage}
          disabled={currentPage === lastPage}
        >
          <span className="material-icons-outlined">skip_next</span>
        </SkipLastPageButton>
      </PaginationContainer>
    </>
  );
}